var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',{staticClass:"yellow"},[_c('span',{staticClass:"white--text"},[_vm._v("Success")])]),_c('v-card-text',[_vm._v(" You are now logged out. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }